import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { technicalEvaluationData } from '../../master/dummayData';
import { forkJoin, Subscription } from 'rxjs';
import { ApiService } from '../../../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../../editorconfig';
import { Table } from 'primeng/table';
import { getTenderOpeningSheetTemplate, getCSTMatrixTemplate } from '../../../pre-ready-tepmlate';
import { environment } from '../../../../environments/environment';
import { FileUpload } from 'primeng/fileupload';
import { UploadService } from '../../../services/upload/upload.service';
import { DmsFile } from '../../../modal/upload/model/upload.model';

interface TenderOpeningSheetRow {
  slNo: number;
  bidderName: string;
  bidReference: string;
  contact: string;
  phone_number: string;
  documentsSubmitted: string;
  remarks: string;
}

@Component({
  selector: 'app-commercial-evaluation',
  standalone: false,
  templateUrl: './commercial-evaluation.component.html',
  styleUrl: './commercial-evaluation.component.scss'
})
export class CommercialEvaluationComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() id: any
  @Input() step: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Output() generatePDFEmitter = new EventEmitter<any>();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  tecData = [

  ];
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  @Output() stepCompleted = new EventEmitter<void>();
  commentForm: FormGroup;
  proposalForm: FormGroup;
  challengeForm: FormGroup;
  technicalEvaluationData = technicalEvaluationData;
  vendors = [];
  allDmsFiles: any[] = [];
  @Input() schemeType: string;
  private subscriptions = new Subscription();
  userID: any;
  constructor(private fb: FormBuilder, private config: PrimeNGConfig, private messageService: MessageService,
    private uploadService: UploadService,
    private api: ApiService, private route: ActivatedRoute) {
    this.commentForm = this.fb.group({
      comment: ['', Validators.required]
    });
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role
  }
  apiUrl = environment.APIUrl
  payload: any;
  commentData: any;
  CSTForm: FormGroup;
  @ViewChild('table') table: Table;
  benchmark: any
  resId: any
  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName
      }
    });
    this.CSTForm = this.fb.group({
      comment: ['', Validators.required],
    });
    this.getStep2();
    this.fetchBenchmarkData();
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.stepDetails?.can_edit) {
        this.isEditorDisabled = false;
        this.CSTForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.CSTForm.disable();
      }
      this.rebuildEditor()
    }, 3000);
  }
  editorReady = false;
  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      readonly: this.isEditorDisabled
    };
  }

  fetchBenchmarkData() {

    this.benchmark = sessionStorage.getItem('benchmark');

    const isMake = this.schemeType?.toLowerCase().includes('make');
    let url
    if (this.schemeType == 'makeI') {
      url = `/make1/financial-evaluation/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`
    } else if (this.schemeType == 'tdf') {
      url = `/tdf/financial/tpr/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`
    } else if (this.schemeType == 'idex') {
      url = `/idex/financial-evaluation/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`
    } else {
      url = `/revenue/financial-evaluation/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`
    }
    const sub = this.api.getAPI(url).subscribe({
      next: (res) => {
        const dmsFiles: DmsFile[] = res.dms_files;
        this.allDmsFiles = dmsFiles;
        // Patch justification if available
        if (res) {
          console.log("res", res)
          this.CSTForm.patchValue({
            comment: res.justification || ''
          });

          // Set uploaded document URL if available
          this.uploadedUrl = res.file || res.comparative_statement_document || '';
          console.log("url", this.uploadedUrl);
        }

        this.resId = res.id;
        this.financialEvaluationId = res.id || null;
        console.log("check", this.resId)

        // Set Q-CST specific fields from API response
        this.qbid_date = res.qbid_date || '';
        this.qbid_time = res.qbid_time || '';
        this.qbid_venue = res.qbid_venue || '';
        this.cst_approval = res.cst_approval || '';
        this.comparative_statement = res.comparative_statement || getTenderOpeningSheetTemplate('Commercial Bid Opening Sheet', this.stepDetails);
        this.cst_sheet = res.cst_sheet || getCSTMatrixTemplate();

        this.vendors = []; // Clear before pushing

        // Handle Make & Non-Make vendors
        const vendorSource = res.vendors || res.da || res.vendor;

        for (const vendorName in vendorSource) {
          const vendorArray = vendorSource[vendorName];

          vendorArray.forEach((entry: any) => {
            console.log(entry)
            this.vendors.push({
              vendor: entry.vendor || entry.da || {}, // vendor object or da object
              benchmarkPrice: entry.benchmark_price || entry.budgetory_quote || '',
              cost_with_taxes: entry.cost_with_taxes || '',
              with_taxes: entry.with_taxes ?? false,
              tax_percentage: entry.tax_percantage ?? null,
              cost: entry.cost ?? null,
              level: entry.level ?? '',
              finalPrice: entry.final_price ?? '',
              vendor_status: entry.vendor_status ?? '',
              status: entry.vendor_status ?? '',
              id: entry.id ?? null,
              name: entry.vendor?.name || vendorName, // fallback to key name
              concurrence_cst: entry.concurrence_cst
            });
          });
        }
        console.log(this.vendors)

        // Populate Tender Opening Sheet data
        this.tenderOpeningSheetData = this.vendors.map((vendor: any, index: number) => ({
          slNo: index + 1,
          bidderName: vendor.vendor?.name || vendor.name || '-',
          bidReference: vendor.vendor?.reference || '-',
          contact: vendor.vendor?.contact || '-',
          phone_number: vendor.vendor?.phone_number || '-',
          documentsSubmitted: 'Commercial Bid Submitted',
          // remarks: vendor.vendor_status
          //   ? (vendor.vendor_status === 'Qualified' ? 'All documents in order' : 'Documents pending')
          //   : 'Pending review'
          remarks: vendor.remark || 'Pending review'
        }));

        // Initialize Commercial Sheet Editor with template
        this.commercialSheetEditorData = res.commercial_sheet_content || getTenderOpeningSheetTemplate('Commercial Bid Opening Sheet', this.stepDetails);
        this.cstSheetEditorData = res.cst_sheet_content || getCSTMatrixTemplate();
      },
      error: (err) => {
        console.error('Error fetching benchmark data:', err);
      }
    });
    this.subscriptions.add(sub);
  }

  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
  }

  onRowEditInit(rowData: any) {
    //console.log(rowData)
    // Optional: Store a copy of original row if needed
    // rowData.originalData = { ...rowData };
    rowData.vendor_status = rowData.status;
  }

  onRowEditSave(rowData: any) {
    // //console.log(rowData)
    if (!this.validateLevel(rowData)) {
      // Don't proceed if level is invalid
      return;
    }
    let payload;
    if (this.schemeType == 'makeI') {
      payload = {
        // proposal_step: this.step.id,
        // comment: rowData.justification,
        vendor_id: rowData.id,
        benchmark_price: rowData.benchmarkPrice,
        cost_with_taxes: rowData.cost_with_taxes,
        level: rowData.level,
        remark: rowData.remark,
        // vendor_status: rowData.status
      };
    } else if (this.schemeType == 'tdf') {
      payload = {
        vendor_eval_id: rowData.id,
        budgetory_quote: rowData.benchmarkPrice,
        level: rowData.level
      };
    }
    else {
      payload = {
        // proposal_step: this.step.id,
        // comment: rowData.justification,
        vendor_id: rowData.id,
        benchmark_price: rowData.benchmarkPrice,
        cost_with_taxes: rowData.cost_with_taxes,
        with_taxes: rowData.with_taxes,
        tax_percantage: rowData.tax_percentage,
        level: rowData.level,
        remark: rowData.remark,
        // vendor_status: rowData.status
      };
      if (rowData.date) {
        payload.concurrence_cst = rowData.date
      }
    }
    let url
    if (this.schemeType == 'makeI') {
      url = `/make1/financial-evaluation/${this.resId}/`
    } else if (this.schemeType == 'tdf') {
      url = `/tdf/financial/tpr/${this.resId}/`
    } else if (this.schemeType == 'idex') {
      url = `/idex/financial-evaluation/${this.resId}/`
    } else {
      url = `/revenue/financial-evaluation/${this.resId}/`
    }
    // let url = this.schemeType == 'makeI' ? `/make1/financial-evaluation/` : `/revenue/financial-evaluation/`
    const sub = this.api.putAPI(url, payload).subscribe((res: any) => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Evaluation updated successfully' });
      this.table.cancelRowEdit(rowData);
      this.fetchBenchmarkData();
    });
    this.subscriptions.add(sub);
  }

  onRowEditCancel(rowData: any, index: number) {
    // Revert to original data
    if (rowData.originalData) {
      this.vendors[index] = { ...rowData.originalData };
    }
  }
  onFileUpload(event: any, rowData: any): void {
    const file = event.target.files[0];
    if (file) {
      rowData.uploadedFile = file;
      rowData.uploadedFileName = file.name;
    }
  }
  getLevel(rowData: any): string {
    if (!this.vendors?.length) return '';

    // Sort vendors by benchmark price ascending
    const sorted = [...this.vendors]
      .filter(v => v.benchmarkPrice != null)
      .sort((a, b) => a.benchmarkPrice - b.benchmarkPrice);


    const index = sorted.findIndex(v => v === rowData);
    return index !== -1 ? `L${index + 1}` : '';
  }
  vendorsDoc: any
  getStep2() {
    if (this.schemeType == 'idex') {
      const sub = this.api.getAPI(`/idex/receipt/bids/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`)
        .subscribe((res: any) => {
          // Extract all values (arrays) from the response object
          const allEntriesArrays = Object.values(res.vendors); // This will be an array of arrays

          // Flatten the arrays into a single array of items
          const allItems = allEntriesArrays.flat();

          // Now group by vendor name
          const vendorMap = new Map();

          allItems.forEach((item: any) => {
            const vendorName = item.vendor.name;
            const criteriaEntry = {
              evaluationId: item.id,
              vendorId: item.vendor.id,
              criteriaId: item.criteria.id,
              proposalStep: item.proposal_step,
              criteriaName: item.criteria.name,
              document: item.document,           // <-- add document path
              document_flag: item.document_flag,
              selectedFile: null
            };

            if (!vendorMap.has(vendorName)) {
              vendorMap.set(vendorName, {
                name: vendorName,
                entries: [criteriaEntry]
              });
            } else {
              vendorMap.get(vendorName).entries.push(criteriaEntry);
            }
          });

          this.vendorsDoc = Array.from(vendorMap.values());
        })
      this.subscriptions.add(sub);
    } else if (this.schemeType == 'tdf') {
      const sub = this.api.getAPI(`/tdf/financial/tpr/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`)
        .subscribe((res: any) => {

          // Extract all values (arrays) from the response object
          const allEntriesArrays = Object.values(res.vendor); // This will be an array of arrays

          // Flatten the arrays into a single array of items
          const allItems = allEntriesArrays.flat();
          // Now group by vendor name
          const vendorMap = new Map();

          allItems.forEach((item: any) => {
            const vendorName = item.vendor.name;
            const criteriaEntry = {
              evaluationId: item.id,
              vendorId: item.vendor?.id || null,
              criteriaId: item.criteria?.id || null,
              proposalStep: item.proposal_step,
              criteriaName: 'Commercial Bid',
              document: item.bid_document,
              document_flag: item.document_flag,
              selectedFile: null
            };


            if (!vendorMap.has(vendorName)) {
              vendorMap.set(vendorName, {
                name: vendorName,
                entries: [criteriaEntry]
              });
            } else {
              vendorMap.get(vendorName).entries.push(criteriaEntry);
            }
          });

          this.vendorsDoc = Array.from(vendorMap.values());
          // this.vendors = res;
        });
      this.subscriptions.add(sub);
    } else if (this.schemeType == 'makeI') {
      const sub = this.api.getAPI(`/make1/upload/dpr/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`)
        .subscribe((res: any) => {

          // Extract all values (arrays) from the response object
          const allEntriesArrays = Object.values(res.da); // This will be an array of arrays

          // Flatten the arrays into a single array of items
          const allItems = allEntriesArrays.flat();
          // Now group by vendor name
          const vendorMap = new Map();

          allItems.forEach((item: any) => {
            const vendorName = item.da.name;
            const criteriaEntry = {
              evaluationId: item.id,
              vendorId: item.vendor?.id || null,
              criteriaId: item.criteria?.id || null,
              proposalStep: item.proposal_step,
              criteriaName: 'Commercial Bid',
              document: item.bid_document,
              document_flag: item.document_flag,
              selectedFile: null
            };


            if (!vendorMap.has(vendorName)) {
              vendorMap.set(vendorName, {
                name: vendorName,
                entries: [criteriaEntry]
              });
            } else {
              vendorMap.get(vendorName).entries.push(criteriaEntry);
            }
          });

          this.vendorsDoc = Array.from(vendorMap.values());
          // this.vendors = res;
        });
      this.subscriptions.add(sub);
    }
    else {
      const sub = this.api.getAPI(`/revenue/technical-evaluation/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`)
        .subscribe((res: any) => {
          //console.log('API Response:', res);

          // Extract all values (arrays) from the response object
          const allEntriesArrays = Object.values(res.vendors); // This will be an array of arrays

          // Flatten the arrays into a single array of items
          const allItems = allEntriesArrays.flat();

          // Now group by vendor name
          const vendorMap = new Map();

          allItems.forEach((item: any) => {
            const vendorName = item.vendor.name;
            const criteriaEntry = {
              evaluationId: item.id,
              vendorId: item.vendor.id,
              // criteriaId: item.criteria.id,
              proposalStep: item.proposal_step,
              criteriaName: item.criteria.name,
              document: item.document,           // <-- add document path
              document_flag: item.document_flag,
              selectedFile: null
            };

            if (!vendorMap.has(vendorName)) {
              vendorMap.set(vendorName, {
                name: vendorName,
                entries: [criteriaEntry]
              });
            } else {
              vendorMap.get(vendorName).entries.push(criteriaEntry);
            }
          });

          this.vendorsDoc = Array.from(vendorMap.values());
          // this.vendors = res;
        });
      this.subscriptions.add(sub);
    }

  }
  onSubmit() {
    const justification = this.CSTForm.get('comment')?.value;
    let url
    if (this.schemeType == 'makeI') {
      url = `/make1/financial-evaluation/${this.resId}/`
    } else if (this.schemeType == 'tdf') {
      url = `/tdf/financial/tpr/${this.resId}/`
      console.log("tdfValue", url);
    } else if (this.schemeType == 'idex') {
      url = `/idex/financial-evaluation/${this.resId}/`
    } else {
      url = `/revenue/financial-evaluation/${this.resId}/`
    }

    // Create FormData for file upload
    const formData = new FormData();
    formData.append('proposal_step', this.step.id);
    formData.append('justification', justification);

      // formData.append('cst_approval', this.cst_approval || '');
      formData.append('comparative_statement', this.comparative_statement || '');
  formData.append('cst_sheet', this.cst_sheet || '');

    // Add file if selected
    if (this.file) {
      formData.append('file', this.file);
    }

    const sub = this.api.putAPI(url, formData).subscribe({
      next: (res) => {
        this.uploadedFileName = ''; // Clear selected file name
        this.file = null; // Clear selected file
        this.fetchBenchmarkData(); // Refresh data to get updated document URL
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `Comparative Statement of Tenders submitted`
        });
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `Failed to submit Comparative Statement of Tenders`
        });
      }
    });
    this.subscriptions.add(sub);
  }
  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: "Proposal Name", value: this.payload.proposal_name },
        { key: "Comments", value: this.CSTForm.get('comment')?.value },

      ]
    };
    this.generatePDFEmitter.emit(payload);
  }
  validateLevel(rowData: any): boolean {
    const pattern = /^L[1-9][0-9]*$/;
    if (!pattern.test(rowData.level)) {
      rowData.level = '';
      // alert('Only values like L1, L2, L3 are allowed.');
      this.messageService.add({
        severity: 'danger',
        summary: 'Fail',
        detail: `Only values like L1, L2, L3 are allowed.`
      });
      return false;
    }
    return true;
  }

  // Update Q-CST specific fields
  updateCstFields() {
    if (!this.financialEvaluationId) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Financial evaluation ID not found'
      });
      return;
    }

    const formData = new FormData();
    formData.append('id', this.financialEvaluationId.toString());
    formData.append('qbid_date', this.qbid_date || '');
    formData.append('qbid_time', this.qbid_time || '');
    formData.append('qbid_venue', this.qbid_venue || '');
    // formData.append('cst_approval', this.cst_approval || '');

    let url;
    if (this.schemeType == 'makeI') {
      url = `/make1/financial-evaluation/${this.financialEvaluationId}/`;
    } else if (this.schemeType == 'tdf') {
      url = `/tdf/financial/tpr/${this.financialEvaluationId}/`;
    } else if (this.schemeType == 'idex') {
      url = `/idex/financial-evaluation/${this.financialEvaluationId}/`;
    } else {
      url = `/revenue/financial-evaluation/${this.financialEvaluationId}/`;
    }

    const sub = this.api.putAPI(url, formData).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Q-Bid details updated successfully',
        });
        this.fetchBenchmarkData(); // refresh the data
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to update Q-Bid details',
        });
      },
    });
    this.subscriptions.add(sub);
  }

  // Check if current step is Q-CST
  get isQcstStep(): boolean {
    return this.stepDetails?.code === 'Q-CST';
  }
  uploadedFileName: string = '';
  uploadedUrl: string = '';
  file: File | null = null;

  // Q-CST specific fields
  qbid_date: string = '';
  qbid_time: string = '';
  qbid_venue: string = '';
  cst_approval: string = '';
  cst_sheet: string = '';
  comparative_statement: string = '';
  financialEvaluationId: number | null = null; // Store the id from API response

  // Tender Opening Sheet data
  tenderOpeningSheetData: TenderOpeningSheetRow[] = [];

  // Commercial Bid Opening Sheet Editor
  commercialSheetEditorData: string = '';
  cstSheetEditorData: string = '';

  // Add a new table row in the Commercial Bid Opening Sheet editor
  addTableRow(): void {
    const newRow = `
      <tr>
        <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"></td>
        <td style="border: 1px solid #ddd; padding: 8px;"></td>
        <td style="border: 1px solid #ddd; padding: 8px;"></td>
        <td style="border: 1px solid #ddd; padding: 8px;"></td>
        <td style="border: 1px solid #ddd; padding: 8px;"></td>
        <td style="border: 1px solid #ddd; padding: 8px;"></td>
        <td style="border: 1px solid #ddd; padding: 8px;"></td>
      </tr>
    `;

    // Find the closing tbody tag and insert the new row before it
    if (this.commercialSheetEditorData.includes('</tbody>')) {
      this.commercialSheetEditorData = this.commercialSheetEditorData.replace('</tbody>', newRow + '</tbody>');
    } else {
      // If no tbody exists, notify user
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please ensure the table structure is correct before adding rows.'
      });
    }
  }

  
}
